import { Controller } from "@hotwired/stimulus"

// The language picker on a session page's Transcript tab (TMS-1615): shows the transcript in
// the language picked.
export default class extends Controller {
  static targets = ["language"]

  switch(event) {
    const locale = event.detail.value
    this.languageTargets.forEach((block) => {
      block.hidden = block.dataset.locale !== locale
    })
  }
}
